import DescriptionList, { DescriptionListProps } from './DescriptionList';

export type { DescriptionListProps };
export default DescriptionList;
